import React, { useEffect, useState } from "react"

import { Link, useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./filters.module.scss"
import Heading from "../../atoms/heading"
import Icon from "../../atoms/icon"
import Wrapper from "../../atoms/wrapper"
import Submenu from "../submenu"

const Filters = ({ currentSport, currentVertical }) => {
  const { allSanityDictionary, allSanitySport, allSanityVertical } =
    useStaticQuery(graphql`
      {
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
        allSanitySport {
          nodes {
            featured
            color
            name
            slug {
              current
            }
          }
        }
        allSanityVertical {
          nodes {
            name
            slug {
              current
            }
            color
          }
        }
      }
    `)

  const allSports = allSanitySport.nodes.map((sport) => {
    const newSport = sport
    newSport.title = sport.name
    newSport.url = `/sport/${sport.slug.current}${
      currentVertical ? `-${currentVertical}` : ""
    }`
    return newSport
  })
  allSports.push({
    title: allSanityDictionary.nodes.find(
      (dictionaryItem) => dictionaryItem.key.current === "general"
    )?.value,
    url: `/sport/general${currentVertical ? `-${currentVertical}` : ""}`,
    slug: {
      current: "general",
    },
  })
  allSports.sort((a, b) => a.title.localeCompare(b.title))

  const featuredSports = allSanitySport.nodes.filter((sport) => sport.featured)
  const otherSports = allSports.filter((sport) => !sport.featured)
  const currentSportInOther = otherSports.find(
    (sport) => sport.slug.current === currentSport
  )
  const currentSportInAll = allSports.find(
    (sport) => sport.slug.current === currentSport
  )

  const allVerticals = allSanityVertical.nodes.map((vertical) => {
    const newVertical = vertical
    newVertical.title = vertical.name
    newVertical.url = `/${currentSport ? `sport/${currentSport}-` : ""}${
      vertical.slug.current
    }`
    return newVertical
  })
  const currentVerticalInAll = allVerticals.find(
    (vertical) => vertical.slug.current === currentVertical
  )

  const [rendered, setRendered] = useState(false)
  useEffect(() => {
    setRendered(true)
  }, [])

  return (
    <div className={styles.filters}>
      <Wrapper className={`${styles.wrapper} ${styles.hideMobile}`}>
        <ul>
          {featuredSports.map((sport) => {
            const sportUrl = `sport/${sport.slug.current}${
              currentVertical ? `-${currentVertical}` : ""
            }`
            return (
              <li key={sport.slug.current} className={styles.item}>
                <Link
                  className={`${styles.link} ${
                    sport.slug.current === currentSport
                      ? styles.link__active
                      : ""
                  } ${
                    sport.color
                      ? styles[`link__${sport.color.replaceAll("-", "")}`]
                      : ""
                  }`}
                  key={sport.slug.current}
                  to={`/${sportUrl}`}
                >
                  {sport.name}
                </Link>
              </li>
            )
          })}
          <li className={`${styles.item} ${styles.item__more}`}>
            <button
              type="button"
              className={`${styles.link} ${
                currentSportInOther ? styles.link__active : ""
              } ${
                currentSportInOther?.color
                  ? styles[
                      `link__${currentSportInOther.color.replaceAll("-", "")}`
                    ]
                  : ""
              }`}
            >
              {currentSportInOther
                ? currentSportInOther.title
                : allSanityDictionary.nodes.find(
                    (item) => item.key.current === "more"
                  )?.value}
              <Icon icon={rendered ? "expand_more" : ""} />
            </button>
            <Submenu menu={otherSports} />
          </li>
        </ul>
        <div className={styles.separator} />
        <ul>
          {allSanityVertical.nodes.map((vertical) => (
            <li key={vertical.name} className={styles.item}>
              <Link
                className={`${styles.link} ${styles.link__vertical} ${
                  vertical.slug.current === currentVertical
                    ? styles.link__active
                    : ""
                } ${
                  vertical.color
                    ? styles[`link__vertical${vertical.color}`]
                    : ""
                }`}
                key={vertical.name}
                to={`/${currentSport ? `sport/${currentSport}-` : ""}${
                  vertical.slug.current
                }`}
              >
                {vertical.name}
              </Link>
            </li>
          ))}
        </ul>
      </Wrapper>
      <Wrapper className={`${styles.wrapper} ${styles.showMobile}`}>
        <Heading level="6" className={styles.title}>
          {
            allSanityDictionary.nodes.find(
              (item) => item.key.current === "filter_by"
            )?.value
          }
        </Heading>
        <ul>
          <li className={`${styles.item} ${styles.item__more}`}>
            <button
              type="button"
              className={`${styles.link} ${
                currentSport ? styles.link__active : ""
              } ${
                currentSportInAll?.color
                  ? styles[
                      `link__${currentSportInAll.color.replaceAll("-", "")}`
                    ]
                  : ""
              }`}
            >
              {currentSport
                ? allSports.find((sport) => sport.slug.current === currentSport)
                    ?.title
                : allSanityDictionary.nodes.find(
                    (item) => item.key.current === "sport"
                  )?.value}
              <Icon icon={rendered ? "expand_more" : ""} />
            </button>
            <Submenu menu={allSports} />
          </li>
          <li className={`${styles.item} ${styles.item__more}`}>
            <button
              type="button"
              className={`${styles.link} ${
                currentVertical ? styles.link__active : ""
              } ${
                currentVerticalInAll?.color
                  ? styles[
                      `link__${currentVerticalInAll.color.replaceAll("-", "")}`
                    ]
                  : ""
              }`}
            >
              {currentVertical
                ? allSanityVertical.nodes.find(
                    (vertical) => vertical.slug.current === currentVertical
                  )?.name
                : allSanityDictionary.nodes.find(
                    (item) => item.key.current === "vertical"
                  )?.value}
              <Icon icon={rendered ? "expand_more" : ""} />
            </button>
            <Submenu menu={allVerticals} />
          </li>
        </ul>
      </Wrapper>
    </div>
  )
}

export default Filters

Filters.propTypes = {
  currentSport: PropTypes.string,
  currentVertical: PropTypes.string,
}

Filters.defaultProps = {
  currentSport: "",
  currentVertical: "",
}
